<template>
  <div id="change">
    <!-- top -->
    <div>
      <topbar />
    </div>
    <!-- logo栏 -->
    <div id="logoContent">
      <span class="logo">
        <a href="index.html"><img src="../../../static/images/logo.png" alt="logo"></a>
      </span>
    </div>
    <!-- 表单 -->
    <div class="content">
      <div class="background">
        <div v-if="center" class="center">
          <div id="title">
            <p>修改昵称/密码</p>
          </div>
          <!-- 表单 -->
          <div id="form">
            <b-form v-if="show" class="form" @submit="submit">
              <b-form-group id="input-group-account" class="margin-bottom">
                <b-input-group size="lg">
                  <p>账号：</p>
                  <span><p>{{ form.account }}</p></span>
                </b-input-group>
              </b-form-group>
              <b-form-group id="input-group-name">
                <b-input-group size="lg">
                  <p>昵称：</p>
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    class="background-color"
                    type="text"
                    required
                    placeholder="请输入昵称"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group id="input-group-previousPassword">
                <b-input-group size="lg">
                  <p>原密码：</p>
                  <b-form-input
                    id="previousPassword"
                    v-model="form.previousPassword"
                    class="background-color"
                    type="password"
                    required
                    placeholder="请输入6~8位的密码"
                    @blur="checkPreviousPassword"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group id="input-group-newPassword">
                <b-input-group size="lg">
                  <p>新密码：</p>
                  <b-form-input
                    id="newPassword"
                    v-model="form.newPassword"
                    class="background-color"
                    type="password"
                    required
                    placeholder="请输入6~8位的密码"
                    @blur="checkNewPassword"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group id="input-group-confirmPassword">
                <b-input-group size="lg">
                  <p>确认密码：</p>
                  <b-form-input
                    id="confirmPassword"
                    v-model="form.confirmPassword"
                    class="background-color"
                    type="password"
                    required
                    placeholder="请再次输入6~8位的密码"
                    @blur="checkComfirmPassword"
                  />
                </b-input-group>
              </b-form-group>
              <b-button id="btn" class="confirmButton" type="submit" variant="danger" size="lg">确 定</b-button>
            </b-form>
          </div>
        </div>
        <!-- 修改完成后的页面 -->
        <div v-if="isCompleted" id="completed">
          <p>修改成功</p>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div>
      <app-footer />
    </div>
    <!-- 遮罩层 -->
    <div v-if="window" id="mask">
      <!-- 弹窗 -->
      <div v-if="window" id="window">
        <div id="content">
          <b-button id="confirm" class="confirmButton" variant="danger" size="lg" @click="submitAfterConfirming">确 定</b-button>
          <b-button id="cancel" class="cancenlButton" size="lg" @click="cancel">取 消</b-button>
        </div>
      </div>
    </div>
    <!-- 提示框 -->
    <div v-if="isAlert" id="prompt">
      <div id="promptContent">
        <b-button size="lg" class="color">{{ message }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
// 导入相关组件
import topbar from '../../components/TopBar.vue'
import footer from '../../components/Footer.vue'

import { UserService } from '@/service/UserService'
export default {
  components: { topbar, 'app-footer': footer },
  data () {
    return {
      form: {
        account: '',
        name: '',
        previousPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      show: true,
      window: false,
      message: '',
      isAlert: false,
      confirm: 0,
      isCompleted: false,
      center: true
    }
  },
  created () {
    this.$store.dispatch('reloadUserInfo')
  },
  mounted () {
    this.reset()
  },
  methods: {
    submit (evt) {
      evt.preventDefault()
      const result = this.checkPassword()
      if (result === 1) { // 两个新密码相等  弹出确认框
        this.window = true
        this.confirm = 1
      }
    },
    reset () {
      const info = new UserService(this.$axios)
      info.getUserAccount().then(res => {
        this.form.account = res.loginName
        this.form.name = res.name
      })
      this.form.previousPassword = ''
      this.form.newPassword = ''
      this.form.confirmPassword = ''
      this.window = false
      this.message = ''
      this.isAlert = false
      this.confirm = 0
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    checkPassword () {
      const firstPassword = this.checkNewPassword()
      const secondPassword = this.checkComfirmPassword()
      if (firstPassword === 1 && secondPassword === 1) {
        // 判断两个密码是否相等
        if (this.form.newPassword !== this.form.confirmPassword) { // 不等
          this.prompt('新密码输入不一致')
          return 0
        } else {
          return 1
        }
      }
    },
    checkPreviousPassword () {
      if (this.form.previousPassword !== '') {
        if (this.form.previousPassword.length < 6) {
          this.prompt('密码需大于6位')
        } else if (this.form.previousPassword.length > 30) {
          this.prompt('请输入30位以下的密码')
        }
      }
    },
    checkNewPassword () {
      if (this.form.newPassword !== '') {
        if (this.form.newPassword.length < 6) {
          this.prompt('密码需大于6位')
          return 0
        } else if (this.form.newPassword.length > 30) {
          this.prompt('请输入30位以下的密码')
          return 0
        } else { // 满足大于6位小于30位
          return 1
        }
      } else {
        return 0
      }
    },
    checkComfirmPassword () {
      if (this.form.confirmPassword !== '') {
        if (this.form.confirmPassword.length < 6) {
          this.prompt('密码需大于6位')
          return 0
        } else if (this.form.confirmPassword.length > 30) {
          this.prompt('请输入30位以下的密码')
          return 0
        } else {
          return 1
        }
      } else {
        return 0
      }
    },
    submitAfterConfirming () {
      if (this.confirm === 1) {
        const data = {
          name: this.form.name,
          oldPwd: this.form.previousPassword,
          newPwd: this.form.newPassword
        }
        this.window = false
        const userinfo = new UserService(this.$axios)
        userinfo.changeUserInfo(data)
          .then((res) => {
            switch (res) {
              case 0:
                this.center = false
                this.isCompleted = true
                this.reset()
                break
              case 1:
                this.prompt('修改失败')
                break
              case 2:
                this.prompt('原密码错误')
                break
              default:
                break
            }
          })
      }
    },
    cancel () {
      this.window = false
    },
    prompt (msg) { // 提示框信息 1.5秒后关闭
      this.message = msg
      this.isAlert = true
      const time = setTimeout(() => {
        this.isAlert = false
        window.clearTimeout(time)
      }, 1500)
    }
  }
}
</script>

<style scoped>
.background{
  width: 1200px;
  height: 620px;
  padding-top: 30px;
  margin: 0 auto;
  background-color: #FFFFFF;
}
.logo{
  margin-top:20px;
  display: inline-block;
  margin-bottom: 20px;
  margin-left: 25px;
}
#change{
  position: relative;
  background-color: #f5f5f5;
  text-align: center;
  color: #2c3e50;
  min-width: 1300px;
  min-height: 1900px;
}
#completed p{
  display: block;
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%,-35%);
  font-size: 24px;
}
#prompt{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#promptContent{
  width: 300px;
  height: 100px;
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%,-50%);
  padding-top: 40px;
  padding-left: 40px;
}
#promptContent b-button{
  width: 80%;
}
#title {
  width: 100%;
  height: 80px;
  background-color: #E3E4E6;
  opacity: 0.8;
  margin-bottom: 40px;
  border-radius: 10px 10px 0 0;
}
#title p {
  font-size: 30px;
  font-weight: 200px;
  line-height: 80px;
  margin: 0;
}
#form p{
  display: inline;
  width: 20%;
  line-height: 45px;
  text-align: right;
}
#btn {
  margin-left: 100px;
  width: 80%;
}
.content {
  width: 100%;
  height: 650px;
}
.center {
  width: 960px;
  height: 560px;
  margin: 0 auto;
  background-color: #FAFAFC;
  border: 1px solid #e9ecef;
  border-radius: 10px;
}
#window {
  width: 500px;
  height: 150px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: floralwhite;
  padding-top: 50px;
  border: 1px solid floralwhite;
  border-radius: 5px;
  z-index: 2;
}
#content {
  height: 50px;
  width: 100%;
  margin: 0 auto;
}
#confirm,
#cancel {
  width: 35%;
  display: inline-block;
  margin-left: 20px;
  margin-right: 15px;
}
#form {
  width: 500px;
  margin: 0 auto;
}
#mask {
  width: 100px;
  height: 100px;
  background-color: rgba(122, 122, 122, 0.7);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
}
#logoContent{
  padding-right: 1100px;
  height: 80px;
  margin-bottom: 20px;
  }
.background-color{
  background-color: #EAEBED;
  opacity: 1;
}
.margin-bottom{
  margin-bottom: 0px;
}
p{
  font-size: 18px;
}
.color{
  background-color: #414141;
}
.cancenlButton{
  background-color: #E0E0E0;
  color: #000;
  border: 1px solid #CECECE;
}
.confirmButton{
  background-color: #E10006;
}
</style>
